import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { Link } from '~shared/components/quill/QuillToolbarIcons';

import { FocusIndicator } from '../FocusIndicator/FocusIndicator';

interface LinkButtonProps {
  onClick?: () => void;
  isLinkSelected: boolean;
  disabled: boolean;
}

const QuillToolBarLinkButton = ({
  onClick,
  isLinkSelected,
  disabled,
}: React.PropsWithChildren<LinkButtonProps>) => {
  const className = cx(
    'relative flex-none h-8 min-w-8 px-2 py-1 m-0',
    'font-sans text-xs text-grey-700 border-0 bg-transparent rounded-1',
    'cursor-pointer outline-none transition-colors duration-100 ease-linear',
    'toolbar-button toolbar-button--math',
    {
      'ql-active': isLinkSelected,
    }
  );

  return (
    <button
      disabled={disabled}
      className={className}
      data-testid="link"
      aria-label={translate('link')}
      type="button"
      onClick={onClick}
    >
      <FocusIndicator
        notOffset
        isInset={!isLinkSelected}
        includesWhiteInset={isLinkSelected}
      />
      <div className="flex items-center justify-center font-600">
        <Link />
      </div>
    </button>
  );
};

export default QuillToolBarLinkButton;
